var _rect, _rect2, _path, _path2, _circle, _circle2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryLangs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.80762,
    width: 14.9368,
    height: 50.9012,
    rx: 7.4684,
    fill: "#B6F3D1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2764,
    width: 38.35,
    height: 50.9012,
    fill: "#3CCD7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.219 48.8252C9.67919 48.8252 6.80957 45.9556 6.80957 42.4157V42.4157C6.80957 38.8759 9.67918 36.0063 13.219 36.0063L50.6256 36.0063L50.6256 48.8252L13.219 48.8252Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7021 27.6167C29.9018 29.0831 32.7674 29.0831 34.967 27.6167",
    stroke: "#37204B",
    strokeWidth: 3.00241,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2025,
    cy: 18.3284,
    r: 6.19172,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2021,
    cy: 18.3286,
    r: 3.39546,
    fill: "#37204B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0963 14.7908L34.9328 18.3386C34.6056 18.5007 34.6286 18.9748 34.97 19.1045L42.0963 21.8105",
    stroke: "#37204B",
    strokeWidth: 2.50948,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5556 9.72897C21.6895 10.0125 21.0022 10.3965 20.6757 10.6253C20.0128 11.0899 19.1106 10.9117 18.6607 10.2273C18.2107 9.54289 18.3834 8.61151 19.0463 8.14698C19.61 7.75197 20.5515 7.24269 21.6786 6.87372C22.8062 6.50461 24.2124 6.24536 25.6676 6.45571C26.4611 6.57041 27.0142 7.32744 26.9032 8.14659C26.7921 8.96575 26.0588 9.53683 25.2653 9.42213C24.3727 9.2931 23.4213 9.44556 22.5556 9.72897ZM40.9908 6.87372C42.1179 7.24269 43.0595 7.75197 43.6232 8.14698C44.2861 8.61151 44.4587 9.54289 44.0088 10.2273C43.5588 10.9117 42.6566 11.0899 41.9937 10.6253C41.6672 10.3965 40.9799 10.0125 40.1138 9.72897C39.2481 9.44556 38.2968 9.2931 37.4041 9.42213C36.6107 9.53683 35.8774 8.96575 35.7663 8.14659C35.6552 7.32744 36.2084 6.57041 37.0018 6.45571C38.457 6.24536 39.8633 6.50461 40.9908 6.87372Z",
    fill: "#37204B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2764 42.3979H22.9828V52.1479C22.9828 53.5862 21.253 54.3165 20.2222 53.3134L19.2002 52.3186C18.326 51.4678 16.9332 51.4678 16.0591 52.3186L15.037 53.3134C14.0063 54.3165 12.2764 53.5862 12.2764 52.1479V42.3979Z",
    fill: "#F46D0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryLangs);
export default __webpack_public_path__ + "static/media/category_langs.8aa850c462a82f899d200d11cc317a04.svg";
export { ForwardRef as ReactComponent };